/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import * as CD from 'app/cd/models/essette-api';
import { bindable } from 'aurelia-typed-observable-plugin';
import { AuthService } from 'app/cd/services/auth-service';
import { apiCall } from 'app/shared/lib/api/api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';

@autoinject()
export class DiagnosisGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected authId: string | null = null;

    protected authDiagnoses: ReadonlyArray<CD.Diagnosis> = [];

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 25;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly service: AuthService,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        await this.loadAuthDiagnoses();
    }

    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuthDiagnoses(): Promise<void> {
        if(!this.authId) return;

        const options: Partial<IQueryLoadOptions> = {
            includeInactive: false,
            sorting: this.sorting,
            page: this.$pager?.page || 0,
            top: this.pageSize
        };

        try {
            this.state.beginLoad();

            const response = await this.service.loadAuthDiagnoses(this.authId, options);
            this.authDiagnoses = response.results;
            this.resultCount = response.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
